import React from "react";
import { Link } from "react-router-dom";
import raidenlogo from "../../assets/Logo/raiden-logo.jpg";
import { FaLinkedin, FaMicrophone, FaTelegram, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import image from '../../assets/images/icon/twitter.png'
 

const FooterTwo = () => {
  return (
    <div className="row justify-content-lg-between    justify-content-start  ">
      <div
        className=" col-12 footer-about-widget"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <a href="index-customer-support.html" className="logo">
          <img
            src={raidenlogo}
            alt="brand"
            className=" mx-0  img-logo"
            style={{ width: "" }}
          />
        </a>
      </div>

      <div
        className="col-lg-3 col-md-3 col-sm-6 footer-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="50"
      >
        <h5 className="footer-title">Products</h5>
        <ul>
          <li>
            <Link to="/raiden-verse">Raiden Verse</Link>
          </li>
          <li>
            <Link to="/raiden-simx">Raiden Simx</Link>
          </li>
          <li>
            <Link to="/raiden-cogni">Raiden COGNI+</Link>
          </li>
          <li>
            <Link to="/raiden-arcviz">Raiden ARCVIZ</Link>
          </li>
        </ul>
      </div>

      <div
        className="col-lg-3 col-md-4 col-sm-6 footer-list"
        style={{ whiteSpace: "nowrap" }}
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <h5 className="footer-title">Services</h5>
        <ul>
          <li>
            <Link to="/unity-game-development">Unity Game Development</Link>
          </li>
          <li>
            <Link to="/unreal-engine-game-development">
              Unreal Game Development
            </Link>
          </li>
           <li>
            <Link to="/ar-vr-development">AR/VR Development</Link>
          </li>
           <li>
            <Link to="/ai-development-company">AI Development</Link>
          </li>
          
          <li>
            <Link to="/blockchain-app">Blockchain</Link>
          </li>
         
          
         
        </ul>
      </div>

      <div
        className="col-lg-3 col-md-3 col-sm-6 footer-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="150"
      >
        <h5 className="footer-title">Company</h5>
        <ul>
          <li>
            <Link to="/about-us">About us</Link>
          </li>
          <li>
            <Link to="/career">Career</Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
        </ul>
      </div>
      <div
        className="col-lg-3 col-md-4 col-sm-6 footer-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="150"
      >
        <h5 className="footer-title">Contact us </h5>
        <div className="d-flex flex-column gap-3">
  <a
    href="mailto:info@raiden.studio"
    target="_blank"
    rel="noopener noreferrer"
    className="d-flex align-items-center gap-2 text-decoration-none"
  >
    <MdEmail className="fs-4" style={{ color: "#f18f27" }} />
    <span style={{ fontSize: "16px", color: "#727272" }}>info@raiden.studio</span>
  </a>

  <a
    href="https://api.whatsapp.com/send?phone=919884036062"
    target="_blank"
    rel="noopener noreferrer"
    className="d-flex align-items-center gap-2 text-decoration-none"
  >
    <FaWhatsapp className="fs-4" style={{ color: "#f18f27" }} />
    <span style={{ fontSize: "16px", color: "#727272" }}>+91 98840 36062</span>
  </a>

  <a
    href="https://www.linkedin.com/company/raidenstudios"
    target="_blank"
    rel="noopener noreferrer"
    className="d-flex align-items-center gap-2 text-decoration-none"
  >
    <FaLinkedin className="fs-4" style={{ color: "#f18f27" }} />
    <span style={{ fontSize: "16px", color: "#727272" }}>LinkedIn</span>
  </a>

   <a
            href="https://x.com/StudiosRaiden"
            target="_blank"
            rel="noopener noreferrer"
            className="d-flex align-items-center gap-2 text-decoration-none"
            style={{ minHeight: "24px" }}
          >
            <div style={{ minWidth: "24px", display: "flex", alignItems: "center" }}>
              <img 
                src={image} 
                style={{ width: '20px', height: '20px', objectFit: 'contain' }} 
                alt="Twitter" 
              />
            </div>
            <span style={{ fontSize: "16px", color: "#727272", lineHeight: "1.2" }}>
              Twitter
            </span>
          </a>

  <a
    href="https://telegram.me/Raidenstudios"
    target="_blank"
    rel="noopener noreferrer"
    className="d-flex align-items-center gap-2 text-decoration-none"
  >
    <FaTelegram className="fs-4" style={{ color: "#f18f27" }} />
    <span style={{ fontSize: "16px", color: "#727272" }}>Telegram</span>
  </a>
</div>

      </div>

      {/* /.footer-list */}
      {/* <div
        className="col-lg-3 col-md-3 col-sm-6 address-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="200"
      >
        <h5 className="footer-title">Address</h5>
        <ul className="info">
          <li>
            <a href="mailto:ib-themes21@gmail.com">deskisupportinc@gmail.com</a>
          </li>
          <li>
            <a href="Tel: 7614123224" className="mobile-num">
              +761 412 3224
            </a>
          </li>
        </ul>
        <ul className="social-icon d-flex">
          {socialContent.map((val, i) => (
            <li key={i}>
              <a href={val.link} target="_blank" rel="noreferrer">
                <i className={`fa ${val.icon}`}></i>
              </a>
            </li>
          ))}
        </ul>
      </div> */}
      {/* /.footer-list */}
    </div>
    //.row
  );
};

export default FooterTwo;
